module.exports = __webpack_public_path__ + "img/Calendarright.33ef85bc.svg";